<template>
    <div ref="root"
         class="project-photo-card rel w-full min-h-12 cursor-pointer shadow rounded-lg overflow-hidden"
         @mouseenter="focus"
         @mouseleave="unfocus">
        <!-- Photo preview -->
        <div :class="classes.photoPreview"
             :style="styles.photoPreview"
             @click="goToPhoto" />

        <!-- Address -->
        <div v-if="address"
             :class="classes.address">
            {{ address }}
        </div>

        <div v-if="focused"
             class="abs t-0.5 r-0.5 _px-0.5 _py-0.25 rounded bg-rock-0.8 blur font-medium text-white text-size--supplementary">
            {{ shotAtLabel }}
        </div>

        <el-button v-if="deletable && focused"
                   class="abs t-0.5 l-0.5 bg-rock-0.8 border-0 blur text-size--supplementary"
                   icon="el-icon-delete-solid text-red-1"
                   circle
                   @click.stop="handleDelete" />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { labelAt } from '@/utils/date'
import { then } from '@/utils/immutable'

import { toPhoto } from '@/models/photos'

const OFFSET_DETECTION = 40

export default {
  components: {

  },
  
  props: {
    photo: { type: Object, default: () => ({}) },
    index: { type: Number, default: null },
    selected: { type: Boolean, default: false },
    deletable: { type: Boolean, default: false }
  },
  data() {
    return {
      focused: false,
      previewed: false,
      x: 50,
      y: 50,
      zoom: 150
    }
  },
  computed: {
    ...mapGetters('photosRevision', [
      'photoJobs', 
      'photoTags', 
      'photoSight',
      'photoPoint',
      'photoPointPreview', 
      'photoFloorPlan',
      'fetchPhotoLoading', 
      'photoJobsLoading', 
      'photoTagsLoading', 
      'fetchPhotoPointPreviewLoading'
    ]),

    classes: function() {
      return {
        address: {
          'abs b-0.5 l-0.5 _px-0.5 _py-0.25 _mr-0.5 rounded bg-rock-0.8 blur font-medium text-white text-size--supplementary': true,
          'max-w-12 truncate': !this.focused
        },
        photoPreview: {
          'wh-full': true
        }
      }
    },

    styles: function() {
      return {
        photoPreview: `
          background-image: url("${this.photo.image.storage_thumb_url}"); 
          background-size: cover; 
          background-position: center;
        `
      }
    },

    shotAtLabel() {
      return this.photo.shotAtLabel || then(this.photo.image.shot_at, x => labelAt(x, { zoned: false, withAlias: false })) || 'Неизвестно'
    },
  
    address() {
      return this.photo.address || toPhoto(this.photo).address
    },

    outerTop() {
      const a = this.$refs.root.getBoundingClientRect()
      const b = this.$refs.root.parentElement.getBoundingClientRect()

      return Math.abs(a.top - b.top) <= OFFSET_DETECTION
    },

    outerBottom() {
      const a = this.$refs.root.getBoundingClientRect()
      const b = this.$refs.root.parentElement.getBoundingClientRect()

      return Math.abs(a.bottom - b.bottom) <= OFFSET_DETECTION
    },

    outerLeft() {
      const a = this.$refs.root.getBoundingClientRect()
      const b = this.$refs.root.parentElement.getBoundingClientRect()

      return Math.abs(a.left - b.left) <= OFFSET_DETECTION
    },

    outerRight() {
      const a = this.$refs.root.getBoundingClientRect()
      const b = this.$refs.root.parentElement.getBoundingClientRect()

      return Math.abs(a.right - b.right) <= OFFSET_DETECTION
    }
  },
  methods: {
    // TODO@refactor: wtf
    ...mapMutations({
      showForm: 'form/SHOW_FORM'
    }),

    ...mapActions('photosRevision', ['fetchPhoto', 'fetchPhotoJobs', 'fetchPhotoTags', 'fetchPhotoPointPreview', 'clearPhotoPointPreview']),

    goToPhoto(event) {
      event.stopPropagation()

      this.$router.push({
        name: 'project.photo',
        params: {
          photoId: this.photo.id
        }
      })
    },

    goToPoint(event) {
      event.stopPropagation()

      this.$router.push({
        name: 'project.plan',
        params: {
          planId: this.photoFloorPlan.id,
          selection: [this.photoPoint.id]
        }
      })
    },

    goToEdit() {
      this.showForm({
        formName: 'photo-upload-form',
        payload: {photo_id: this.photo.id}
      })
    },

    async focus() {
      this.focused = true
    },

    unfocus() {
      this.focused = false
    },

    openPreview() { 
      this.previewed = true
    },

    closePreview() { 
      this.previewed = false
      this.x = 50
      this.y = 50
      this.zoom = 150
    },

    movePreview(event) {
      this.x += event.movementX
      this.y += event.movementY
    },

    zoomPreview(event) {
      event.preventDefault()

      this.zoom = Math.max(150, this.zoom + event.deltaY)
    },

    handleDelete() {
      this.$emit('delete', this.photo.id)
    }
  }
}
</script>
